import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {BackupService} from "../../services/backup.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {DatePipe, DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {FormService} from "../../services/form.service";
import {YesNoPipe} from "../../pipes/yes-no.pipe";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-store-detail',
    imports: [NgIf, ReactiveFormsModule, NgForOf, DatePipe, RouterLink, YesNoPipe, DecimalPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-store me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Store anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Store bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Store
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <div class="col-12 col-md-4">
                        <label>Name</label>
                        <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                        <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
                    </div>
                    <h5 class="mt-3 mb-2">Standort</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>Land</label>
                            <select class="form-control" formControlName="id_country" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let country of countries" [ngValue]="country.id">
                                    {{ country.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.country }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Region</label>
                            <select class="form-control" formControlName="id_region" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let region of regions" [ngValue]="region.id">
                                    {{ region.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.region }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Lage</label>
                            <select class="form-control" formControlName="id_position" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let position of positions" [ngValue]="position.id">
                                    {{ position.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.position }}</p>
                        </div>
                    </div>
                    <h5 class="mt-3 mb-2">Partner</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>Franchisegeber</label>
                            <select class="form-control" formControlName="id_franchisor" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let franchisor of franchisors" [ngValue]="franchisor.id">
                                    {{ franchisor.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                <a [routerLink]="['/franchisor/', form.value.id_franchisor]">{{ form.value.franchisor }}</a>
                            </p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Franchisenehmer</label>
                            <select class="form-control" formControlName="id_franchisee" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let franchisee of franchisees" [ngValue]="franchisee.id">
                                    {{ franchisee.name }}
                                </option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                <a [routerLink]="['/franchisee/', form.value.id_franchisee]">{{ form.value.franchisee }}</a>
                            </p>
                        </div>
                    </div>
                    <h5 class="mt-3 mb-2">Kontakt</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="contact" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.contact }}
                                <span class="text-muted" *ngIf="!form.value.contact">Nicht gesetzt</span>
                            </p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Telefon</label>
                            <input type="text" class="form-control" formControlName="phone" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                @if (form.value.phone) {
                                    <a (click)="$event.stopPropagation()" [href]="'tel:' + form.value.phone">{{ form.value.phone }}</a>
                                    <a class="ms-3" (click)="$event.stopPropagation()" [href]="'https://wa.me/' + form.value.phone"><i class="fa-brands fa-whatsapp text-success fa-2x"></i></a>
                                }
                                <span class="text-muted" *ngIf="!form.value.phone">Nicht gesetzt</span>
                            </p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>E-Mail</label>
                            <input type="text" class="form-control" formControlName="email" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                @if (form.value.email) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + form.value.email">{{ form.value.email }}</a> }
                                <span class="text-muted" *ngIf="!form.value.email">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>
                    <h5 class="mt-3 mb-2">Adresse</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>PLZ</label>
                            <input type="text" class="form-control" formControlName="zip" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.zip }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Ort</label>
                            <input type="text" class="form-control" formControlName="city" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.city }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Straße</label>
                            <input type="text" class="form-control" formControlName="street" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.street }}</p>
                        </div>
                    </div>
                    <h5 class="mt-3 mb-2">Betrieb</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>Größe (m²)</label>
                            <input type="number" class="form-control" formControlName="area" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.area }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Miete Netto (€)</label>
                            <input type="number" class="form-control" formControlName="rent" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.rent }}
                                <span class="text-muted" *ngIf="!form.value.rent">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>Datum Eröffnet</label>
                            <input type="date" class="form-control" formControlName="date_opened" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.date_opened | date: "dd.MM.yyyy" }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Datum Geschlossen</label>
                            <input type="date" class="form-control" formControlName="date_closed" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.date_closed | date: "dd.MM.yyyy" }}
                                <span class="text-muted" *ngIf="!form.value.date_closed">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>
                    <h5 class="mt-3 mb-2">Status &amp; Kommentar</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-6">
                            <label>Status</label>
                            <select class="form-control" formControlName="status" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option value="In Planung">In Planung</option>
                                <option value="In Betrieb">In Betrieb</option>
                                <option value="Außer Betrieb">Außer Betrieb</option>
                                <option value="Übernommen">Übernommen</option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.status }}</p>

                            <label>Kommentar</label>
                            <textarea class="form-control" formControlName="comment" rows="5" *ngIf="viewMode != ViewMode.VIEW"></textarea>
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.comment }}
                                <span class="text-muted" *ngIf="!form.value.comment">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>
                    <h5 class="mt-3 mb-2">Gebühren</h5>
                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label>Franchisegebühr (%)</label>
                            <input type="number" class="form-control" formControlName="franchise_charge" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.franchise_charge }}</p>

                        </div>
                        <div class="col-12 col-md-4">
                            <label>Werbegebühr (€)</label>
                            <input type="number" class="form-control" formControlName="advertising_charge" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.advertising_charge }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Sonderumsätze</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="special_sales">
                            </div>
                            <p class="gray" *ngIf="viewMode == ViewMode.VIEW">{{ form.value.special_sales | yesNo }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>Einstiegsgebühr (€)</label>
                            <input type="number" class="form-control" formControlName="entry_charge" *ngIf="viewMode != ViewMode.VIEW">

                            <p class="gray" *ngIf="viewMode == ViewMode.VIEW">{{ form.value.entry_charge | number:'1.0-0' }}</p>
                        </div>
                    </div>
                    <!-- Öffnungszeiten -->
                    <h5 class="mt-3 mb-2">Öffnungszeiten</h5>
                    <div class="row">
                        <div class="col">
                            <div class="row align-items-center mb-2" *ngFor="let day of ['monday','tuesday','wednesday','thursday','friday','saturday','sunday']; let i = index">
                                <div class="col-3 text-capitalize">
                                    {{ ['Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Sonntag'][i] }}
                                </div>
                                <div class="col-4" *ngIf="viewMode != ViewMode.VIEW">
                                    <div [formGroup]="formService.getFormGroup(form, 'opening_hours.' + day)">
                                        <div class="d-flex align-items-center">
                                            <input type="time" class="form-control me-2" formControlName="time_from">
                                            <span class="me-2">bis</span>
                                            <input type="time" class="form-control" formControlName="time_to">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4" *ngIf="viewMode == ViewMode.VIEW">
                                    @if (form.value.opening_hours && form.value.opening_hours[day] && (form.value.opening_hours[day].time_from || form.value.opening_hours[day].time_to)) {
                                        {{ form.value.opening_hours[day].time_from || '—' }} - {{ form.value.opening_hours[day].time_to || '—' }}
                                    } @else {
                                        <span class="text-muted">Nicht gesetzt</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <h5 class="mt-3 mb-2" *ngIf="viewMode != ViewMode.INSERT">Integration &amp; Daten</h5>
                    <div class="row" *ngIf="viewMode != ViewMode.INSERT">
                        <div class="col-4">
                            <label>ready2order Token</label>
                            <p>
                                <span class="text-success" *ngIf="form.value.account_token">Vorhanden</span>
                                <span class="text-danger" *ngIf="!form.value.account_token">Nicht vorhanden</span>
                            </p>
                        </div>
                        <!--<div class="col-4">
                            <label>Daten vorhanden ab</label>
                            <p>{{ store?.first_date_available | date: "dd.MM.yyyy" }}</p>
                        </div>-->
                        @if (form.value.account_token && form.value.sync_status == 'idle') {
                            <div class="col-4">
                                <label>Daten geladen ab</label>
                                <p>{{ store?.first_date_loaded | date: "dd.MM.yyyy" }}</p>
                            </div>
                            <div class="col-4">
                                <label>Daten geladen bis</label>
                                <p>{{ store?.last_date_loaded | date: "dd.MM.yyyy" }}</p>
                            </div>
                        }
                        @if (form.value.sync_status == 'syncing') {
                            <div class="col-8">
                                <label>Daten</label>
                                <p class="bg-info">Die Daten werden derzeit geladen!</p>
                            </div>
                        }
                        @if (form.value.sync_status == 'waiting') {
                            <div class="col-8">
                                <label>Daten</label>
                                <p class="bg-info">Die Daten werden demnächst geladen!</p>
                            </div>
                        }
                        @if (form.value.account_token) {
                            <div class="col-4">
                                <label>Angelegte Produkte</label>
                                <p>
                                    <span>{{ store?.products.length }}</span>
                                </p>
                            </div>
                            <div class="col-4">
                                <label>Angelegte Produktgruppen</label>
                                <p>
                                    <span>{{ store?.productgroups.length }}</span>
                                </p>
                            </div>
                        }
                    </div>
                </form>

                <div class="mt-3 d-flex flex-wrap justify-content-between gap-2">
                    @if (viewMode == ViewMode.VIEW) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        </div>
                        <!--<button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>-->

                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-info" (click)="requestAccountToken()">ready2order Token einrichten</button>
                            <button type="button" class="btn btn-info" (click)="syncData()" *ngIf="form.value.account_token && form.value.date_opened && form.value.sync_status == 'idle'">ready2order Daten laden</button>
                            <button type="button" class="btn btn-info" (click)="export()">PDF Export</button>

                            @if (accessService.environmentIsDev()) {
                                <button type="button" class="btn btn-info" (click)="importProductGroups()" [disabled]="loading" *ngIf="store?.productgroups.length == 1">
                                    Produktgruppen importieren<span *ngIf="loading"><i class="fa fa-spinner fa-spin ms-2"></i></span>
                                </button>
                                <button type="button" class="btn btn-info" (click)="importProducts()" [disabled]="loading" *ngIf="store?.products.length == 0">
                                    Produkte importieren<span *ngIf="loading"><i class="fa fa-spinner fa-spin ms-2"></i></span>
                                </button>
                            }
                        </div>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                            <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Abbrechen</button>
                        </div>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Abbrechen</button>
                        </div>
                    }
                </div>

            </div>
        </div>
    `
})
export class StoreDetailComponent implements OnInit, OnDestroy {

    accessService = inject(AccessService);
    formService = inject(FormService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private backupService = inject(BackupService);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_store!: string;
    viewMode!: ViewMode;
    store: any;

    countries!: any[];
    regions!: any[];
    positions!: any[];
    franchisors!: any[];
    franchisees!: any[];

    loading = false;

    franchiseeChanges$!: Subscription;

    ngOnInit(): void {
        this.id_store = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_store == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_country: ['', Validators.required],
            id_region: ['', Validators.required],
            id_position: ['', Validators.required],
            id_franchisor: ['', Validators.required],
            id_franchisee: ['', Validators.required],
            name: [null, Validators.required],
            zip: [null, Validators.required],
            city: [null, Validators.required],
            street: [null, Validators.required],
            area: [null, Validators.required],
            rent: [null],
            date_opened: [null, Validators.required],
            date_closed: [null],
            status: ['', Validators.required],
            comment: [null],
            franchise_charge: [8, Validators.required],
            advertising_charge: [0, Validators.required],
            entry_charge: [25000, Validators.required],
            account_token: [null],
            contact: [null],
            phone: [null],
            email: [null],
            special_sales: [false],
            sync_status: ['idle'],
            opening_hours: this.fb.group({
                monday: this.fb.group({ time_from: [null], time_to: [null] }),
                tuesday: this.fb.group({ time_from: [null], time_to: [null] }),
                wednesday: this.fb.group({ time_from: [null], time_to: [null] }),
                thursday: this.fb.group({ time_from: [null], time_to: [null] }),
                friday: this.fb.group({ time_from: [null], time_to: [null] }),
                saturday: this.fb.group({ time_from: [null], time_to: [null] }),
                sunday: this.fb.group({ time_from: [null], time_to: [null] }),
            }),

            country: [null],
            region: [null],
            position: [null],
            franchisor: [null],
            franchisee: [null],
        });

        if (this.id_store !== '0') {
            this.getStore();
        }

        this.dataService.request("Country/listForSelection").subscribe(response => {
            this.countries = response.countries;
        });

        this.dataService.request("Region/listForSelection").subscribe(response => {
            this.regions = response.regions;
        });

        this.dataService.request("Position/listForSelection").subscribe(response => {
            this.positions = response.positions;
        });

        this.dataService.request("Franchisor/listForSelection").subscribe(response => {
            this.franchisors = response.franchisors;

            if (this.franchisors.length == 1) {
                this.form.patchValue({ id_franchisor: this.franchisors[0].id });
            }
        });

        this.dataService.request("Franchisee/listForSelection").subscribe(response => {
            this.franchisees = response.franchisees;
        });

        this.franchiseeChanges$ = this.form.get('id_franchisee').valueChanges.subscribe(val => {

            if (this.viewMode == ViewMode.INSERT) {
                const franchisee = this.franchisees.find(f => f.id == val);

                this.form.patchValue({
                    contact: franchisee.contact,
                    phone: franchisee.phone,
                    email: franchisee.email,
                    zip: franchisee.zip,
                    city: franchisee.city,
                    street: franchisee.street,
                })
            }
        });
    }

    ngOnDestroy() {
        this.franchiseeChanges$?.unsubscribe();
    }

    getStore(): void {
        this.dataService.request('Store/get', {
            id_store: this.id_store
        }).subscribe(response => {
            this.store = response.store;

            this.store.account_token = this.store.account_token != null;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.store.id,
            id_country: this.store.id_country,
            id_region: this.store.id_region,
            id_position: this.store.id_position,
            id_franchisor: this.store.id_franchisor,
            id_franchisee: this.store.id_franchisee,
            name: this.store.name,
            zip: this.store.zip,
            city: this.store.city,
            street: this.store.street,
            area: this.store.area,
            rent: this.store.rent,
            date_opened: this.store.date_opened,
            date_closed: this.store.date_closed,
            status: this.store.status,
            comment: this.store.comment,
            franchise_charge: this.store.franchise_charge,
            advertising_charge: this.store.advertising_charge,
            entry_charge: this.store.entry_charge,
            account_token: this.store.account_token,
            contact: this.store.contact,
            phone: this.store.phone,
            email: this.store.email,
            special_sales: this.store.special_sales == 1,
            sync_status: this.store.sync_status,

            country: this.store.country,
            region: this.store.region,
            position: this.store.position,
            franchisor: this.store.franchisor,
            franchisee: this.store.franchisee,
        });

        // Patch opening hours if available
        const opening_hours = this.loadOpeningHours(this.store?.opening_hours);
        if (opening_hours) {
            this.form.get('opening_hours')?.patchValue(opening_hours);
        }
    }

    private loadOpeningHours(opening_hours: any[]): any {

        const days = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
        const result: any = {};

        for (const day of days) {
            const foundDay = opening_hours.find(oh => oh.weekday === day);
            if (foundDay) {
                result[day] = {
                    time_from: foundDay.time_from.substring(0, 5),
                    time_to: foundDay.time_to.substring(0, 5)
                };
            } else {
                result[day] = { time_from: null, time_to: null };
            }
        }
        return result;
    }

    save(): void {
        this.dataService.request('Store/save', {
            store: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/store']);
            this.toastrService.success('Der Store wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Store/update', {
            store: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getStore();
            this.toastrService.success('Der Store wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/store']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getStore();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Store wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Store/delete', {
                    id_store: this.id_store
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Store wurde gelöscht');
                });
            }
        });
    }

    requestAccountToken() {
        this.dataService.request('Store/requestAccountToken', {
            id_store: this.id_store
        }).subscribe(response => {
            const uri = response?.requestAccountToken?.grantAccessUri;
            if (uri) {
                Swal.fire({
                    title: 'Zugriff gewähren',
                    html: `<p>Bitte öffnen Sie den folgenden Link, um Zugriff auf ready2order zu gewähren:</p>
                           <p><a href="${uri}" target="_blank" rel="noopener noreferrer">${uri}</a></p>`,
                    icon: 'info',
                    confirmButtonText: 'OK'
                }).then(_ => {
                    this.getStore();
                });
            } else {
                this.toastrService.error('Grant-Access-Link konnte nicht abgerufen werden.');
            }
        });
    }

    importProductGroups() {
        this.loading = true;
        this.dataService.request('Store/importProductGroups', {
            id_store: this.id_store
        }).subscribe(response => {
            this.loading = false;
            this.toastrService.success('Die Produktgruppen wurden importiert.');
        });
    }

    importProducts() {
        this.loading = true;
        this.dataService.request('Store/importProducts', {
            id_store: this.id_store
        }).subscribe(response => {
            this.loading = false;
            this.toastrService.success('Die Produkte wurden importiert.');
        });
    }

    syncData() {
        this.dataService.request('Store/syncData', {
            id_store: this.id_store
        }).subscribe(response => {
            this.getStore();
            this.toastrService.success('Die Daten für den Store werden demnächst synchronisiert.');
        });
    }

    export() {
        this.dataService.request("Store/export", {
            id_store: this.id_store
        }).subscribe(response => {
            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            }
        });
    }
}
